// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2EptF","right":"styles_right__1VpIL"};